// This file was auto-generated by Fern from our API Definition.
/** A component included in the signed payload. */
const WebhookPayloadComponentValues = {
    /**
     * The raw request body. */
    Body: "BODY",
    /**
     * The delivery timestamp value from the timestamp header. */
    Timestamp: "TIMESTAMP",
    /**
     * The notification/callback URL. */
    NotificationUrl: "NOTIFICATION_URL",
    /**
     * A provider-assigned message identifier. */
    MessageId: "MESSAGE_ID",
};
export const WebhookPayloadComponent = Object.assign(Object.assign({}, WebhookPayloadComponentValues), { _visit: (value, visitor) => {
        switch (value) {
            case WebhookPayloadComponent.Body:
                return visitor.body();
            case WebhookPayloadComponent.Timestamp:
                return visitor.timestamp();
            case WebhookPayloadComponent.NotificationUrl:
                return visitor.notificationUrl();
            case WebhookPayloadComponent.MessageId:
                return visitor.messageId();
            default:
                return visitor._other();
        }
    } });
